import { isFieldEmpty, isFileTypeImage, getSecurePasswordString } from "@limitless/common/utils";
export const PASSWORD_VALIDATION_MESSAGE = getSecurePasswordString();
export const INITIAL_FIELD = {
  value: "",
  pristine: true
};
export const INITIAL_DROP_DOWN_FIELD = {
  label: "",
  value: "",
  pristine: true
};
export const INITIAL_BOOL_FIELD = {
  value: false,
  pristine: true
};
export const INITIAL_OBJECT_FIELD = {
  value: {},
  pristine: false
};

/**
 * Centralised Password validation
 *
 * @param {String} password
 */
export const isPasswordValid = password => {
  let result = false;
  if (!password) {
    return result;
  }
  const checkSpecial = new RegExp("(?=.*[?|\\[\\]{}\"'()<>:;.,\\\\/\\!@#\\$%\\^&\\*_-])").test(password);
  const checkUpperLowerLength = new RegExp("(?=.*[a-zA-Z0-9])(?=.{12,})").test(password);
  const checkUpperLetter = new RegExp("(?=.*[A-Z].*)").test(password);
  const checkNumeric = new RegExp("(?=.*[0-9])").test(password);
  const checkTilde = password.indexOf("~") === -1 ? false : true;
  if (checkUpperLowerLength && checkUpperLetter && checkNumeric && (checkSpecial || checkTilde)) {
    result = true;
  }
  return result;
};
export const areFieldsPristine = fields => {
  return Object.keys(fields).every(key => {
    const field = fields[key];
    return field && field.pristine;
  });
};
export const areFieldsTouched = fields => {
  return Object.keys(fields).some(key => {
    const field = fields[key];
    return field && !field.pristine;
  });
};
export const areAnyFieldsPristine = fields => {
  return Object.keys(fields).some(key => {
    const field = fields[key];
    return field && field.pristine;
  });
};
export const getAllDirtyFields = fields => {
  const data = {};
  Object.keys(fields).map(key => {
    const field = fields[key];
    if (!field.pristine) {
      data[key] = field.value;
    }
  });
  return data;
};
export const getAllFieldValues = fields => {
  const data = {};
  Object.keys(fields).map(key => {
    const field = fields[key];
    data[key] = field.value;
  });
  return data;
};
const REGEX_MAP = {
  specialChars: {
    pattern: "^[^`~!@#$%^&*()+={}\\[\\]|\\\\:;“<,>.?๐฿]*$",
    getError: label => `${label} doesn't support special characters`
  },
  specialCharsNoNumbers: {
    pattern: "^[^\\d`~!@#$%^&*()+={}\\[\\]|\\\\:;“<,>.?๐฿]*$",
    getError: label => `${label} doesn't support special characters or numbers`
  },
  cssCharsOnly: {
    pattern: "^[^`^{}<>]*",
    getError: label => `${label} doesn't support special characters or numbers`
  }
};
export const validateLengthAndContent = (field, options) => {
  const {
    label,
    regexType = "cssCharsOnly",
    maxLength = 128,
    minLength = 1,
    checkEmpty = true,
    dataKey
  } = options;
  const regexDetails = REGEX_MAP[regexType];
  const regex = RegExp(regexDetails.pattern, "g");
  const {
    pristine,
    value
  } = field;
  let error;
  if (!pristine) {
    if (isFieldEmpty(value) && checkEmpty) {
      error = `${label} is mandatory`;
    } else if (!regex.test(value)) {
      error = regexDetails.getError(label);
    } else if (value.length > maxLength) {
      error = `${label} should be max ${maxLength} characters long`;
    } else if (value.trim().length < minLength) {
      error = `${label} should be at least ${minLength} characters long`;
    }
  }
  if (error) {
    return {
      [dataKey]: error
    };
  }
  return null;
};
export const validateImageAttachment = file => {
  let imageAttachmentError = "";
  const sizeInMB = (file.size / 1024 ** 2).toFixed(2);
  if (file) {
    if (!isFileTypeImage(file.type) && process.env.REACT_APP_NAME !== "ExpertMobileApp" || file.type === "image/gif") {
      imageAttachmentError = "File type is not correct";
    } else if (sizeInMB > 5) {
      imageAttachmentError = "File size is too big. Max file size is 5MB";
    }
  }
  return {
    imageAttachmentError
  };
};